import BaseOption from "%/dynamic-component-editor/classes/base-option";
import { inspectorTools } from "%/dynamic-component-editor/inspector/inspector-tool-map";

export default class StyledTextVariant extends BaseOption {
  static userInterfaceComponent = {
    label: "Variant",
    component: inspectorTools.SIMPLE_PICKER,
    props: {
      options: [
        {
          id: "standard",
          name: "Standard",
        },
        {
          id: "accent",
          name: "Accent",
        },
        {
          id: "subtle",
          name: "Subtle",
        },
      ],
    },
  };

  static defaultValue = "standard";
}
